import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .preview-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .upload-container {
    position: relative;
    width: calc(100% - 4px);
    height: 200px;
    border: 2px dashed var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    overflow: hidden;

    &.drag-over {
      background: var(--sds-color-background-positive-hover);
    }
  }

  .upload-container:hover {
    border-color: var(--sds-color-border-brand-default);
    background: var(--sds-color-background-brand-subtle);
  }

  .upload-container.uploading {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-200);
    color: var(--sds-color-text-default-secondary);
    text-align: center;
    padding: var(--sds-size-space-400);
  }

  .camera-icon {
    color: var(--sds-color-text-default-tertiary);
  }

  .current-file {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .preview-image-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .preview-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: var(--sds-size-radius-200);
  }

  .upload-overlay {
    position: absolute;
    inset: 0 0 0 0;
    background: rgb(0 0 0 / 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--sds-size-space-200);
    color: white;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .upload-container:hover .upload-overlay {
    opacity: 1;
  }

  .upload-icon {
    color: white;
  }

  .upload-text {
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-medium);
  }

  .uploading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-200);
    color: var(--sds-color-text-default-secondary);
  }

  .spinner {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .preview-controls {
    display: flex;
    justify-content: center;
  }

  .error-message {
    color: var(--sds-color-text-danger-default);
    font-size: var(--sds-typography-body-size-small);
    margin-top: var(--sds-size-space-200);
  }

  /* Cropping canvas styles */
  .crop-canvas {
    display: block;
    cursor: grab;
    touch-action: none;
  }

  .crop-canvas:active {
    cursor: grabbing;
  }
`;
